// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2_TiR","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3ajcp","gfeWrapper":"CalendarEvent_gfeWrapper__1iiXU"};